'use strict';

angular.module('projectsManagement')
  .controller('ProjectsEmbeddedListCtrl', [
    '$scope', 'projectsEmbeddedListViewModel', 'masterId',
    function ($scope, viewModel, masterId) {
      $scope.model = new viewModel(masterId);
    }
  ]);
